package com.ustadmobile.core.util.stringvalues

fun emptyStringValues() = MapStringValues(emptyMap())
